import React from "react";
import styled from "styled-components";
import destate1 from "../images/destate1.webp";
import destate2 from "../images/destate2.webp";

import { motion } from "framer-motion";

const Project3 = () => {
  return (
    <>
      <motion.div
        initial={{ scaleY: 0 }}
        animate={{ scaleY: 1 }}
        exit={{ scaleY: 0 }}
        transition={{ duration: 0.8 }}
      >
        <Main>
          <CaseStudy>
            <h2>Destate</h2>

            <p>
              Destate is a web template that I created targeting the real estate
              industry for people to use for their own real estate business and
              build trust and engagement with their customers by providing them
              with a better User Interface on the Web. <br /> By taking User
              Interface ideas by visiting different types of websites of the
              same industry and even visited platforms like dribble to get
              inspiration for building a good User Interface that will bring
              great results. <br /> Feel free to check out the Project by
              visiting the Live Link.
            </p>

            <h2>TOOLS USED</h2>

            <div className="tools">
              <code>HTML</code>
              <code>CSS</code>
              <code>JavaScript</code>
              <code>Next.JS</code>
              <code>Styled Components</code>
              <code>GIT</code>
              <code>GITHUB</code>
            </div>

            <a
              href="https://dark-estate.netlify.app/"
              target="_blank"
              rel="noreferrer"
            >
              View Site
            </a>
          </CaseStudy>

          <Slider>
            <img src={destate1} alt="destate" loading="eager" />
            <img src={destate2} alt="destate" loading="lazy" />
          </Slider>
        </Main>
      </motion.div>
    </>
  );
};

export default Project3;

const Main = styled.main`
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  position: relative;

  @media screen and (max-width: 760px) {
    margin: 4rem 0;
  }
`;

const CaseStudy = styled.div`
  flex: 1;
  padding: 6rem 2rem 0;
  width: 100%;
  height: 100%;

  @media screen and (max-width: 740px) {
    padding: 6rem 0;
  }

  h2 {
    text-align: center;
    font-size: 30px;
    text-transform: uppercase;
    letter-spacing: 3px;
    margin-bottom: 2rem;
  }

  p {
    font-size: 22px;
    margin-bottom: 2rem;
  }

  a {
    font-size: 22px;
    color: ${(props) => props.theme.dark.custom};
    font-weight: bold;
    text-transform: uppercase;
  }

  .tools {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    text-transform: uppercase;
    margin-bottom: 2rem;
    gap: 1rem;
    flex-wrap: wrap;

    code {
      background-color: ${(props) => props.theme.dark.text};
      color: ${(props) => props.theme.dark.primary};
      padding: 5px 10px;
      font-weight: bold;
    }
  }
`;

const Slider = styled.div`
  margin-top: 2rem;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex: 1;
  display: flex;
  overflow-x: scroll;

  ::-webkit-scrollbar {
    display: none;
  }

  img {
    height: 350px;
    object-fit: contain;
    margin: 0 2rem;
  }

  @media screen and (max-width: 740px) {
    img {
      width: 95%;
      min-height: 250px;
      object-fit: cover;
    }
  }
`;
